import { render, staticRenderFns } from "./Meditations.vue?vue&type=template&id=2d72fa64&scoped=true&"
import script from "./Meditations.vue?vue&type=script&lang=js&"
export * from "./Meditations.vue?vue&type=script&lang=js&"
import style0 from "./Meditations.vue?vue&type=style&index=0&id=2d72fa64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72fa64",
  null
  
)

export default component.exports